import { api } from "./client";

interface AuthResponse {
  token: string;
  refreshToken: string;
  user: { id: number; email: string; name: string; role: string };
  tenant: { id: number; name: string; slug: string; plan: string };
}

export async function login(email: string, password: string): Promise<AuthResponse> {
  return api.post("auth/login", { json: { email, password } }).json<AuthResponse>();
}

export async function signup(data: { email: string; password: string; name: string; companyName: string }): Promise<AuthResponse> {
  return api.post("auth/signup", { json: data }).json<AuthResponse>();
}

export async function logout() {
  try { await api.post("auth/logout"); } catch { /* ignore */ }
}

export async function getMe() {
  return api.get("auth/me").json<{ user: Record<string, unknown> }>();
}
